import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32a3636d")

_pushScopeId("data-v-32a3636d")
const _hoisted_1 = { class: "absolute bottom-14 left-0 w-full" }
const _hoisted_2 = { class: "bg-white rounded-lg drop-shadow-md triangle mx-4 p-4" }
const _hoisted_3 = {
  key: 0,
  class: "h-64 flex flex-col items-center justify-center py-8"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "取得中...", -1)
const _hoisted_5 = {
  key: 1,
  class: "h-64 flex flex-col overflow-x-scroll"
}
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "pt-2 flex justify-end text-right" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 定型メッセージを登録 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_loading_icon = _resolveComponent("m-loading-icon")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKeyword = $event)),
        type: "search",
        name: "search",
        placeholder: "絞り込み...",
        class: "w-full bg-primary-100 rounded-md border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 mb-4 leading-8 transition-colors duration-300"
      }, null, 512), [
        [_vModelText, _ctx.searchKeyword]
      ]),
      (_ctx.load)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_m_loading_icon),
            _hoisted_4
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_5, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredTemplates, (messageTemplate) => {
              return (_openBlock(), _createBlock("div", {
                key: messageTemplate.ref.id,
                class: "w-full mb-3 flex"
              }, [
                _createVNode("div", {
                  class: "p-1 mt-2 mr-2 text-gray-500 cursor-pointer transform duration-300",
                  onClick: ($event: any) => (_ctx.changeOpenTemplate(messageTemplate.ref.id))
                }, [
                  _createVNode(_component_m_icon, {
                    type: "chevron-right",
                    width: "3",
                    class: ["transform", {
                'rotate-90': _ctx.openTemplateIds.includes(messageTemplate.ref.id)
              }]
                  }, null, 8, ["class"])
                ], 8, ["onClick"]),
                _createVNode("div", {
                  class: "px-3 py-2 flex-1 flex justify-between items-center bg-primary-100 rounded-md cursor-pointer duration-300 transition-colors border border-primary-100 hover:border-primary-500",
                  onClick: ($event: any) => (_ctx.select(messageTemplate.data.content))
                }, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("p", _hoisted_7, _toDisplayString(messageTemplate.data.heading), 1),
                    _withDirectives(_createVNode("p", { class: "mt-1 text-xs text-gray-700" }, _toDisplayString(messageTemplate.data.content), 513), [
                      [_vShow, _ctx.openTemplateIds.includes(messageTemplate.ref.id)]
                    ])
                  ]),
                  (
                messageTemplate.ref.path.includes('tutors') ||
                messageTemplate.ref.path.includes('admins')
              )
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: "text-gray-500 hover:text-secondary-500 duration-300 transition-colors",
                        onClick: _withModifiers(($event: any) => (_ctx.edit(messageTemplate.ref.id)), ["stop"])
                      }, [
                        _createVNode(_component_m_icon, {
                          type: "pencil",
                          class: "transform"
                        })
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 8, ["onClick"])
              ]))
            }), 128))
          ])),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_m_button, {
          outline: "",
          color: "secondary-500",
          "hover-color": "secondary-600",
          onClick: _ctx.register
        }, {
          default: _withId(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
})